import styled from "styled-components";

export const MainContainer = styled.div`
	min-height: 100vh;
	width: 80%;
	margin: 0 auto;
	font-family: "Poppins", sans-serif;
`;
